import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BdsFleetComponent } from './bds-fleet.component';

@NgModule({
    declarations: [BdsFleetComponent],
    imports: [CommonModule],
})
export class BdsFleetModule {}
